import { NavLink } from 'react-router-dom'
import { useAuth } from '@/shared/auth/AuthContext'
import { useAlerts, useAnomalies, useShifts } from '@/shared/api/queries'
import { isSerious } from '@/shared/format/tones'
import { Icon, Logo } from '@/shared/ui/Icon'
import { menuFor, SCREENS } from '../navigation'

export function Rail({ onNavigate }: { onNavigate: () => void }) {
  const { user, can, hasModule } = useAuth()
  const alerts = useAlerts(!!user && hasModule('risk'))
  const anomalies = useAnomalies(!!user && can('anomalies.read') && hasModule('risk'))
  const shifts = useShifts()
  if (!user) return null

  const counters = {
    alerts: alerts.data?.data.filter((a) => isSerious(a.severity) && !a.read_at).length ?? 0,
    anomalies: anomalies.data?.data.filter((a) => a.status !== 'resolved').length ?? 0,
    shifts:
      shifts.data?.data.filter(
        (s) => s.status === 'pending_validation' || s.status === 'discrepancy',
      ).length ?? 0,
  }

  return (
    <aside className="rail">
      <div className="rail__head">
        <Logo className="rail__mark" />
        <div className="rail__id">
          <p className="rail__word">Sahel Fuel Control</p>
          <p className="rail__tenant">{user.name}</p>
        </div>
      </div>
      <nav className="rail__nav" aria-label="Navigation principale">
        {menuFor(user.role).map((group) => {
          const visible = group.entries
            .map((p) => SCREENS[p])
            .filter((e): e is NonNullable<typeof e> => !!e)
            .filter(
              (e) => (!e.capability || can(e.capability)) && (!e.module || hasModule(e.module)),
            )
          if (visible.length === 0) return null
          return (
            <div key={group.title}>
              <p className="nav-group">{group.title}</p>
              {visible.map((e) => {
                const n = e.counter ? counters[e.counter] : 0
                return (
                  <NavLink key={e.path} to={e.path} className="nav-link" onClick={onNavigate}>
                    <Icon name={e.icon} />
                    <span>{e.short}</span>
                    {n > 0 && <span className="nav-link__tail">{n}</span>}
                  </NavLink>
                )
              })}
            </div>
          )
        })}
      </nav>
      <div className="rail__foot">
        <div className="rail__plan">
          <span>Rôle</span>
          <b>{user.role}</b>
        </div>
        <p>
          {user.stations?.length
            ? `${user.stations.length} station(s) rattachée(s)`
            : 'Périmètre : tout le réseau'}
        </p>
      </div>
    </aside>
  )
}
